import * as yup from 'yup';

export const validationSchema = yup.object({
    title: yup
        .string('Enter valid lesson name')
        .min(10, 'Lesson name must be at least 10 characters')
        .max(50, 'Lesson name must be at most 50 characters')
        .required('Lesson Name is required'),
    description: yup
        .string('Enter valid description')
        .required('Description is required')
        .test('maxWords', 'Description must be at most 1500 words', (value) => {
            if (!value) return true;
            const plainText = value
                ? value
                      .replace(/<[^>]*>/g, '')
                      .replace(/&nbsp;/g, ' ')
                      .trim()
                : '';
            const words = plainText
                ? plainText.split(/\s+/).filter(Boolean).length
                : 0;
            return words <= 1500;
        }),
    video: yup.string('Enter valid file'),
    resourceTitle: yup.string('Enter valid category'),
    externalLink: yup
        .string('Enter valid link')
        .matches(
            /^https?:\/\/[a-zA-Z0-9\-.]+\.com(?:\/.*)?$/,
            'Please enter a valid URL',
        ),
    // .required('Resource title is required')
});

export const initialValues = {
    title: '',
    description: '',
    video: '',
    resourceTitle: '',
    externalLink: '',
};
